import { render, staticRenderFns } from "./shareholder.vue?vue&type=template&id=5a951f83&scoped=true&"
import script from "./shareholder.vue?vue&type=script&lang=js&"
export * from "./shareholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a951f83",
  null
  
)

export default component.exports